module.exports = __webpack_public_path__ + "static/RB11-008fad9d7923c944afa7f60ace4c9d23.mp4";